@if (listConfigs) {
  <gk-dynamic-list
    [listConfigs]="listConfigs"
    [listState]="listState"
    [apiFullFilter]="filters"
    (dispatchMapAction)="handleMapAction($event)"
  ></gk-dynamic-list>
}
